import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';

@Injectable({
  providedIn: 'root'
})
export class MarvFileService {
    
    constructor() {}
    
    static base64ToArrayBuffer(base64: any) {
        let binaryString = window.atob(base64);
        let binaryLen = binaryString.length;
        let bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
            let ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }
    
    static  BlobToBase64(blob: Blob): Promise<string|null> {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                let base64 = (typeof reader.result === 'string' ? reader.result : null);                
                resolve(base64);
            }
            reader.readAsDataURL(blob);
        });
    }

    static async downloadByteArray(filename: string, byte: any, type: string) {
        let blob = new Blob([byte], { type: type });
        await MarvFileService.downloadBlob(filename, blob);
    }

    static async downloadBlob(filename: string, blob: Blob) {   
        const info = await Device.getInfo();    
        if(info.platform === 'web'){ 
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        }
        else{
            let base64 = await MarvFileService.BlobToBase64(blob);
            if(base64){
                let statusFile = await Filesystem.writeFile({
                    path: filename,
                    data: base64,
                    directory: Directory.Temporary,
                });
                if(statusFile?.uri){
                    await FileOpener.openFile({
                        path: statusFile.uri,
                    });
                }
            }
        }
    }
    
}